export default "__VITE_ASSET__D4xH0jdu__"